import { render } from "./ExhibitionEditPage.vue?vue&type=template&id=5bf6936f&scoped=true"
import script from "./ExhibitionEditPage.vue?vue&type=script&lang=js"
export * from "./ExhibitionEditPage.vue?vue&type=script&lang=js"

import "./ExhibitionEditPage.vue?vue&type=style&index=0&id=5bf6936f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf6936f"]])

export default __exports__